import React from 'react';
import ReactDOM from 'react-dom';
import { Field, reduxForm } from 'redux-form';


const validate = values => {
    const errors = {}
    if (!values.email) {
        errors.email = 'Required'
    }

    if (!values.password) {
        errors.password = 'Required'
    }else if (values.password.length < 6) {
        errors.password = 'Password must have minimum 6 characters'
    }

    return errors
}

const renderField = ({ input, name,className,placeholder, title, type, meta: { touched, error } }) => (

    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <input {...input}  placeholder={placeholder} name={name} className={className} type={type}/>
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)


class SignupForm extends React.Component {
    render() {
        const { handleSubmit } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <Field component={renderField} placeholder="E-mail" title='E-mail' type="text" className="form-control" name="email" />

                <Field component={renderField} placeholder="Password" title='Password' type="password" className="form-control" name="password" />

                <button type="submit" className="btn btn-primary btn-block btn-lg m-t-40">Sign up</button>
            </form>
        );
    }
}

// Decorate the form component
SignupForm = reduxForm({
  form: 'SignupForm',
  validate,
})(SignupForm);

export default SignupForm;


// WEBPACK FOOTER //
// ./containers/login/SignupForm.js